import {
  STRIPE_CARD_CAPTURE_PATH,
  STRIPE_CARD_SAVED_PARAM,
} from '../constants/constants';

/**
 * Where the Stripe card form sends the customer once the card is saved. Same-origin only: the
 * value reaches the page on the query string, so anything absolute would be an open redirect.
 */
export const stripeCardSavedReturnUrl = path =>
  `${path}?${STRIPE_CARD_SAVED_PARAM}=true`;

/**
 * The Stripe card form is a standalone page (public/payment/stripe.html) rather than a React
 * component, so everything it needs travels on the query string.
 *
 * Built key by key rather than from an object literal because URLSearchParams turns a missing
 * value into the literal string "undefined", which the page would then treat as a real one.
 *
 * Returns null when the response is not a usable Stripe one, so callers can fall through rather
 * than navigate to a page that cannot work.
 */
export const buildStripeCardCaptureUrl = (checkout, returnUrl) => {
  if (!checkout) {
    return null;
  }
  const {
    publishableKey,
    clientSecret,
    responseUrl,
    orderId,
    savedCardBrand,
    savedCardLastFour,
    savedCardExpiry,
    messages,
  } = checkout;

  if (!publishableKey || !clientSecret || !responseUrl) {
    return null;
  }

  const params = new URLSearchParams();
  params.set('publishableKey', publishableKey);
  params.set('clientSecret', clientSecret);
  params.set('responseUrl', responseUrl);
  if (orderId) {
    params.set('orderId', orderId);
  }
  if (savedCardBrand) {
    params.set('savedCardBrand', savedCardBrand);
  }
  if (savedCardLastFour) {
    params.set('savedCardLastFour', savedCardLastFour);
  }
  if (savedCardExpiry) {
    params.set('savedCardExpiry', savedCardExpiry);
  }
  // Warnings such as "the saved card has expired" are rendered on the card-on-file page for
  // Braintree; handing over to Stripe would otherwise drop them.
  const messageItem = messages && messages.find(item => item && item.text);
  const message = messageItem && messageItem.text;
  if (message) {
    params.set('message', message);
  }
  if (returnUrl) {
    params.set('returnUrl', returnUrl);
  }

  return `${STRIPE_CARD_CAPTURE_PATH}?${params.toString()}`;
};
